exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{font-family:Arial Narrow\\,Arial;font-size:2}#spacersm{padding-top:2.5rem}hr{width:30rem;size:1;color:#a5a29b}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.scss
// module id = ./src/app/footer/footer.component.scss
// module chunks = app